var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
export var StepperControlContext = createContext({});
export var StepperControlProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), serviceReturn = _b[0], setServiceReturn = _b[1];
    var _c = useState(), veiculo = _c[0], setVeiculo = _c[1];
    var _d = useState(), processo = _d[0], setProcesso = _d[1];
    var _e = useState(), historico = _e[0], setHistorico = _e[1];
    var _f = useState(), crv = _f[0], setCrv = _f[1];
    var _g = useState(true), disableButtonAdvance = _g[0], setDisableButtonAdvance = _g[1];
    var _h = useState(0), activeStep = _h[0], setactiveStep = _h[1];
    var handlePrevStep = function () {
        var newActiveStep = activeStep - 1;
        setactiveStep(newActiveStep);
    };
    var handleNextStep = function () {
        var newActiveStep = activeStep + 1;
        setactiveStep(newActiveStep);
    };
    var moveThroughStep = function (step) {
        setactiveStep(step);
    };
    return (_jsx(StepperControlContext.Provider, __assign({ value: {
            serviceReturn: serviceReturn,
            setServiceReturn: setServiceReturn,
            activeStep: activeStep,
            disableButtonAdvance: disableButtonAdvance,
            setactiveStep: setactiveStep,
            setDisableButtonAdvance: setDisableButtonAdvance,
            handlePrevStep: handlePrevStep,
            handleNextStep: handleNextStep,
            moveThroughStep: moveThroughStep,
            veiculo: veiculo,
            setVeiculo: setVeiculo,
            processo: processo,
            setProcesso: setProcesso,
            historico: historico,
            setHistorico: setHistorico,
            crv: crv,
            setCrv: setCrv,
        } }, { children: children })));
};
